module.exports = __webpack_public_path__ + "assets/img/36_586.0c3536b8.jpg";